class User {
    constructor() {
        this.id = Math.round(Math.random()*1000)
        this.email = ""
    }
}

export default User;